import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_STACKED = "/images/branding/logo-stacked.png";
export const LOGO_STACKED_WHITE = "/images/branding/logo-stacked.png";
export const LOGO_STACKED_COLOR = "/images/branding/logo-seal.png";
export const LOGO_SEAL = "/images/branding/logo-seal.png";
export const HERO_BG_IMG = "/images/branding/hero-bg.jpg";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token from localStorage as fallback (when cookies don't work cross-site)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smzbt_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}
